import React, { ReactElement } from "react";

import cx from "classnames";

import { SvgIcon, COLORS } from "../SvgIcon";

import styles from "./Dropdown.scss";
import { DropdownOptionType } from "./types";

export interface DropdownOptionProps<T extends string | number | boolean> {
  option: DropdownOptionType<T>;
  selected?: boolean;
  highlighted?: boolean;
  onSelect: (option: DropdownOptionType<T>) => void;
  selectedLabel?: string;
}

export function DropdownOption<T extends string | number | boolean>({
  option,
  selected,
  highlighted,
  onSelect,
  selectedLabel = "",
}: DropdownOptionProps<T>): ReactElement {
  const TagName = option.href && !option.disabled ? "a" : "button";
  const optionClassName = cx(styles["dropdown-option"], {
    [styles.selected]: selected,
    [styles.disabled]: option.disabled,
    [styles.highlighted]: highlighted,
  });

  return (
    <TagName
      ref={(ref: HTMLButtonElement | HTMLAnchorElement | null) => {
        if (ref && highlighted) {
          ref.focus();
        }
      }}
      className={optionClassName}
      href={option.href}
      onClick={(e) => {
        if (TagName !== "a") {
          e.preventDefault();
        }
        if (!option.disabled) {
          onSelect(option);
        }
      }}
      role="option"
      aria-selected={selected}
    >
      {option.label || option.value}
      {selected && (
        <>
          <SvgIcon
            icon="check"
            color={COLORS.DOVE}
            className={styles["selected-option-icon"]}
          />
          <span className={styles["selected-option"]}>{selectedLabel}</span>
        </>
      )}
    </TagName>
  );
}
